import React, { useEffect, useState } from "react";
import { useAuthStore } from "../store/useAuthStore";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
    const { authUser, loading, checkAuth, hasTriedAuth } = useAuthStore();
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const verifyUser = async () => {
            if (!authUser && !hasTriedAuth) {
                await checkAuth();
            }
            setChecking(false);
        };

        verifyUser();
    }, [authUser, checkAuth, hasTriedAuth]);

    if (loading || checking) {
        return <div>loading...</div>;
    }

    if (!authUser) {
        console.log("redirecting to login!", authUser);
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
